//Admin/ReportCriteria/Set/{AuthToken}/
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash"
import { Button, Grid, Typography, Box, Collapse, Select, MenuItem, Skeleton, TextField } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { reportcriteriaModify, selectReportCriteriaEntities, reportcriteriaClear, updateReportCriteria, reportcriteriaResetStatus } from '../../../reducers/admincenter_reportcriteria';
import { fetchDataReport, datareportResetStatus } from '../../../reducers/admincenter_datareport';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import { fetchGroups } from '../../../reducers/admincenter_groups';
import ReportCriteriaGroupSelect from './ReportCriteriaGroupSelect';
import ReportCriteriaFlags from './ReportCriteriaFlags';
import ReportCriteriaDates from './ReportCriteriaDates';
import { selectActiveProducts, selectReportsForGuid, selectReportsForProduct } from '../../../reducers/reference_reportproduct';
import { fetchUIReport, uireportResetStatus } from '../../../reducers/admincenter_uireport';

/**
 * 
{
"ReportCriteria":
{
"ReportGuid": "97069626-6A92-4BA5-AC4B-B47969B454D9",
"SelectedAssessmentProduct": "HRA200",
"ParticipantGuid": "5FEA08D8-4F8B-4CF8-957A-2EC1FE8B36ED",
"AssessmentGuid": "C83D7CEE-1870-467B-953A-E414006D5C57",
"ReportOutputFormat": "XML",
"FirstRowHeader": "1",
"ReportGroupName": "Arbitrary Name Passed By Caller",
"IncludeAdditionalQuestions": "1",
"ExcludeInactiveParticipants": "0",
"DateRangeStart": "2015-01-01",
"DateRangeEnd": "2016-12-31",
"HRAStartedInDateRange": "0",
"HRANotStartedInDateRange": "0",
"HRACompletedInDateRange": "1",
"HRANotCompletedInDateRange": "0",
"GroupGuidList":["6C096600-B754-49A0-A72D-23CC85548FC7","032AAA24-4222-4FD2-AC42-2F690FCCE860","6F8E2BCC-AC19-4353-B245-A6F74DE7F7E1","45642721-13D9-4A15-9220-F8B4CF11B3A6","5DED27D7-D094-4295-800F-3CE85B3B4AF5","9EE86F41-5A96-4984-A4BE-DD93FD893B7A","5E4AB781-A30A-4D47-9751-C0D453505AEF","4C1C8A83-F70F-44A4-BEDB-966D16389367","D7D6843F-DD37-4464-9B75-22D872304B24","0CD7527D-5D34-4176-AACE-F404BF825FFF"]
}'
 */
const ReportCriteria = (props) => {
    const dispatch = useDispatch()

    const { user: currentUser } = useSelector((state) => state.auth);

    const SelectProductFrame = props.ReportTab.AdminReports.SelectProductFrame
    const ReportOptions = props.ReportTab.AdminReports.ReportOptions.ReportOptions
    const ReportFormatFrame = props.ReportTab.AdminReports.ReportOptions.ReportFormatFrame
    const ReportTypeFrame = props.ReportTab.AdminReports.ReportTypeFrame
    const DateRangeFrame = props.ReportTab.AdminReports.ReportOptions.DateRangeFrame
    const DateCriteriaFrame = props.ReportTab.AdminReports.ReportOptions.DateCriteriaFrame



    const ReportCriteria = useSelector(state => selectReportCriteriaEntities(state))
    const Products = useSelector(state => selectActiveProducts(state))
    const Reports = useSelector(state => selectReportsForProduct(state, ReportCriteria.SelectedAssessmentProduct))
    const ReportArray = useSelector(state=>selectReportsForGuid(state, ReportCriteria.ReportGuid))
    const ReportObject = ReportArray 
                && ReportArray[0] 
                && ReportArray.filter(x=> {return x.ProductTypeKeyName === ReportCriteria.SelectedAssessmentProduct}).length>0
                ? ReportArray.filter(x=> {return x.ProductTypeKeyName === ReportCriteria.SelectedAssessmentProduct})[0] 
                : []
    const [GenerateReport, setGenerateReport] = useState(false)
  //console.log('report criteria stuff',{cri:ReportCriteria, pro:Products, rep:Reports, repAr: ReportArray})
    const validated =
        ReportCriteria.SelectedAssessmentProduct
            && ReportCriteria.SelectedAssessmentProduct.length > 3
            && ReportCriteria.ReportGuid
            && ReportCriteria.ReportGuid.length > 3
            && ReportCriteria.GroupGuidList.length > 0 ? false : true

    const admingroupsStatus = useSelector(state => state.admingroups.status)
    const dataReportStatus = useSelector(state => state.datareports.status)
    const uiReportStatus = useSelector(state => state.uireports.status)
    const reportCriteriaStatus = useSelector(state => state.reportcriterias.status)
    const [isExpanded, setIsExpanded] = useState(true)

    useEffect(() => {
        if (admingroupsStatus === 'idle') {
            dispatch(fetchGroups({ authToken: currentUser.AuthToken }))
        }
    }, [admingroupsStatus, dispatch])

    useEffect(() => {
    }, [dataReportStatus, dispatch]
    )
    const handleModifyLocal = (k, v) => {
        dispatch(reportcriteriaModify({ Key: k, Value: v }))
        if (k==='SelectedAssessmentProduct'){
            dispatch(reportcriteriaModify({ Key: 'ReportGuid', Value: "" }))
        }

    }
    const handleClear = () => {
        dispatch(reportcriteriaClear())
    }

    const ReportToVI={
        "BFAB12B2-CD8A-4E9A-B73C-4B3E9C783BA7":"BFAB12B2-CD8A-4E9A-B73C-4B3E9C783BA7"
    }
    useEffect(() => {
        if (GenerateReport === true) {
            
            if (dataReportStatus === 'idle' && ReportObject.ReportFamilyKeyName==='RESULT SET') {                
                dispatch(fetchDataReport({ AuthToken: currentUser.AuthToken, ReportCriteria: ReportCriteria }))
                setGenerateReport(false)
            } else
            if (uiReportStatus === 'idle' && ReportObject.ReportFamilyKeyName==='JSON OUTPUT') {
                
                dispatch(updateReportCriteria({ AuthToken: currentUser.AuthToken, ReportCriteria: ReportCriteria }))
                .then( res =>{

                    dispatch(fetchUIReport({ AuthToken: currentUser.AuthToken, VIGuid: ReportToVI[ReportCriteria.ReportGuid] }))
                }
                    )
                setGenerateReport(false)
            }
        }
    }, [dispatch, GenerateReport, dataReportStatus, uiReportStatus])


    const ProductSelect = () => {
        const options = Products.map((x) => {
            return (<MenuItem value={x.ProductTypeKeyName}>{x.SurveyDescription || x.ProductTypeName}</MenuItem>)
        })
        return (
            <TextField
                select
                variant="standard"
                sx={{ width: "100%", overflow: "hidden" }}
                value={ReportCriteria.SelectedAssessmentProduct === "" ? null : ReportCriteria.SelectedAssessmentProduct}
                label="Product"
                placeholder='Select Product'
                onChange={(e, nv) => { handleModifyLocal("SelectedAssessmentProduct", e.target.value) }}
            >
                {options}
            </TextField>
        )
    }

    const ReportType = () => {
        const ReportTypes = [...new Set(Reports.filter(y => { return y.ReportClassKeyName === 'ADMIN' }).map(x => { return x.ReportFamilyKeyName }))]
        const Options = []
        for (var l = 0; l < ReportTypes.length; l++) {
            Options.push(<Typography sx={{pl:1 }} variant="button" >{ReportTypes[l]==="JSON OUTPUT"? "Dashboards" : "Data Reports"}</Typography>)
            const thisCategory = Reports.filter(x => { return x.ReportFamilyKeyName === ReportTypes[l] })
            for (var h = 0; h < thisCategory.length; h++) {
                Options.push(<MenuItem value={thisCategory[h].ReportTypeId_Guid}>{thisCategory[h].ReportTypeName}</MenuItem>)

            }
        }
        // const options = Reports.map((x) => {
        //     return (<MenuItem value={x.ReportTypeGuid}>{x.ReportName}</MenuItem>)
        // })
        return (
            <TextField
                select
                variant="standard"
                sx={{ width: "100%", overflow: "hidden" }}
                value={ReportCriteria.ReportGuid === "" ? null : ReportCriteria.ReportGuid}
                disabled={!ReportCriteria.SelectedAssessmentProduct}
                label="Report"
                placeholder='Select Report'
                onChange={(e, nv) => { handleModifyLocal("ReportGuid", e.target.value) }}
            >
                {Options}
            </TextField>
        )
    }

    const GenerateReportCriteria = () => {
        setIsExpanded(false)
        dispatch(reportcriteriaResetStatus())
        if (ReportObject.ReportFamilyKeyName==='JSON OUTPUT'){

            dispatch(uireportResetStatus())
        }
        if (ReportObject.ReportFamilyKeyName==='RESULT SET'){

            dispatch(datareportResetStatus())
        }
        setGenerateReport(true)

    }

    return (

        <Grid container direction="row" alignItems="center" justifyContent="start">
            <Grid item xs={1}>
                <Button variant="text" sx={{ color: "#000000" }} onClick={() => { setIsExpanded(!isExpanded) }}>
                    {isExpanded ? <ArrowDropUp /> : <ArrowDropDown />}
                </Button>
            </Grid>
            <Grid item xs={3}>
                <Typography variant="h6" align="left">Report Filters</Typography>
            </Grid>

            <Grid item xs={12}>

                <Collapse in={isExpanded} timeout="auto" unmountOnExit>


                    <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>
                        <Grid item xs={12}>
                            <Typography variant="caption" fontStyle="italic" align="left">{props.ReportTab.AdminReports.Instruction.InstructionText}</Typography>
                        </Grid>
                        <Grid item xs={7}>
                            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                                <Grid item xs={6}>
                                    <ProductSelect />
                                </Grid>
                                <Grid item xs={6}>
                                    <ReportType />
                                </Grid>
                                <Grid xs={12}>
                                    <Box my={2} px={2}>
                                        <ReportCriteriaDates />
                                    </Box>
                                </Grid>
                                <Grid xs={12}>
                                    <Box my={2} px={2}>
                                        <ReportCriteriaFlags />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={5}>
                            {
                                admingroupsStatus === 'success' ?
                                    (
                                        <Box mt={2} sx={{ height: "220px", alignItems: "center", justifyContent: "center" }}>
                                            <ReportCriteriaGroupSelect SelectLocation="REPORT CRITERIA" />
                                        </Box>
                                    )

                                    : (
                                        <Box mt={2} sx={{ height: "220px", alignItems: "center", justifyContent: "center" }}>
                                            <Skeleton variant="rectangular" animation="wave" sx={{ height: 0, paddingTop: "30%" }} />
                                        </Box>

                                    )}
                        </Grid>
                        <Grid xs={3}>
                            <Box mt={2}>
                                <Button variant="contained" color="success" disabled={validated} onClick={() => GenerateReportCriteria()}>{props.ReportTab.AdminReports.GenerateReportButton.GenerateReportLabel}</Button>
                            </Box>
                        </Grid>
                        <Grid xs={3}>
                            <Box mt={2}>
                                <Button variant="contained" color="error" onClick={() => handleClear()}>{props.ReportTab.AdminReports.ResetSearchButton.ResetSearchLabel}</Button>
                            </Box>
                        </Grid>
                        <Grid xs={12}>
                            <Box mt={2}>
                            </Box>
                        </Grid>
                    </Grid>

                </Collapse>

            </Grid>
        </Grid>
    )

}
export default ReportCriteria
